<script setup>
import {useI18n} from "vue-i18n";

const { t } = useI18n()

</script>

<template>
  <div class="flex items-start space-x-9 responsive-body-small">
    <div>
      <span class="block font-bold responsive-body-medium">{{ t('storeCredit.title') }}</span>
      <span class="text-bw-lightDarkGrey italic block" v-html="t('storeCredit.description')"></span>
    </div>
  </div>
</template>